var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5525 7.74008C13.41 7.74008 13.2675 7.68758 13.155 7.57508L8.99997 3.42008L4.84497 7.57508C4.62747 7.79258 4.26747 7.79258 4.04997 7.57508C3.83247 7.35758 3.83247 6.99758 4.04997 6.78008L8.60247 2.22758C8.81997 2.01008 9.17997 2.01008 9.39747 2.22758L13.95 6.78008C14.1675 6.99758 14.1675 7.35758 13.95 7.57508C13.845 7.68758 13.695 7.74008 13.5525 7.74008Z",
    fill: "#7A5AF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.9374C8.6925 15.9374 8.4375 15.6824 8.4375 15.3749V2.75244C8.4375 2.44494 8.6925 2.18994 9 2.18994C9.3075 2.18994 9.5625 2.44494 9.5625 2.75244V15.3749C9.5625 15.6824 9.3075 15.9374 9 15.9374Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpFilled);
export default __webpack_public_path__ + "static/media/arrow-up_filled.b8008838c2be81b7e709407c36a55ab2.svg";
export { ForwardRef as ReactComponent };